<div class="col-md-12" >
    <div class="menu-container" >
        <div (click)="menuOpen = !menuOpen">
            <button class="btn btn-primary btn-block btn-block-wrap dropdown-toggle">{{getActiveNavLink()}}</button>
        </div>
        <div class="menu" [hidden]="!menuOpen" (click)="menuOpen = false">
            <nav class="card nav flex-column">
                <li class="nav-item" *ngFor="let link of navLinks">
                        <a mat-button #NavigationLink [routerLink]="link.url" class="nav-link" [class.active]="urlIsActive(link.url)">
                            <i [ngClass]="link.iconClass"></i>&nbsp;{{link.label}}
                        </a>
                </li>
            </nav>
        </div>
    </div>
</div>

<div class="col-md-8" style="float: left;">
    <div class="alert alert-warning">
        Don't forget to select the items you wish to export!
    </div>
    <router-outlet></router-outlet>
</div>

<div class="col-md-4" style="float: right; margin-top: 1em;">
    <div class="mb-3" [class.btn-group]="canExpand()">
        <ng-container *ngIf="canExpand()">
            <button (click)="expandAll(true)" class="btn btn-secondary btn-sm">
                Expand All
            </button>
            <button (click)="expandAll(false)" class="btn btn-secondary btn-sm">
                Collapse All
            </button>
        </ng-container>
        <button (click)="selectAll(true)" class="btn btn-secondary btn-sm" style="border-radius: 0;">
            Select All
        </button>
        <button (click)="selectAll(false)" class="btn btn-secondary btn-sm" style="border-radius: 0; margin-left: -1px;">
            Deselect All
        </button>
    </div>

    <table class="table table-bordered text-sm">
        <thead>
            <tr>
                <th colspan="2">
                    Selected Dossier Items
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th style="width:60%;">Themes</th>
                <td>{{dto(trim).themeIds.length}}</td>
            </tr>
            <tr>
                <th>Projects</th>
                <td>{{dto(trim).projectIds.length}}</td>
            </tr>
            <tr>
                <th>Activities</th>
                <td>{{dto(trim).activityIds.length}}</td>
            </tr>
        </tbody>
    </table>

    <span style="font-weight: bold;">Dossier Export</span>
    <div class="card">
        
        <div class="mb-3">
            <div [ngStyle]="{'padding-top': !requirementsMet() ? '30px' : '10px' }" ></div>

            <label class="text-muted text-sm">
                Activities to include in the dossier export:
            </label>

            <label class="text-muted text-sm">
                <input type="checkbox" [(ngModel)]="allPeriodType"(change)="typeChanged()">
                All time
            </label>
            
            <div style="display:flex; justify-content: center;">
                <label class="text-muted text-sm" style="padding-right: 4rem;">
                    Start Date
                </label>
                <label class="text-muted text-sm" style="padding-right: 3rem;">
                    End Date
                </label>
            </div>

            <div style="display:flex; justify-content: center;">
                
                <div class="col-6 input-group input-group-sm no-left-padding" style="padding-right:20px !important;">								
                    <input [disabled]="this.allPeriodType" [matDatepicker]="startDatePicker" placeholder="mm/dd/yyyy" class="form-control form-control-sm no-padding"
                    [(ngModel)]="startDate" (dateChange)="dateChange()" [max] ="endDate">
                    <mat-datepicker #startDatePicker startView="year" [touchUi]="touchEnabled"></mat-datepicker>
                    <mat-datepicker-toggle [for]="startDatePicker" class="input-group-addon no-padding mat-icon-overide"></mat-datepicker-toggle>
                </div>

                <div class="col-6 input-group input-group-sm no-left-padding">						
                    <input [disabled]="this.allPeriodType" [matDatepicker]="endDatePicker" placeholder="mm/dd/yyyy" class="form-control form-control-sm no-padding"
                    [(ngModel)]="endDate" (dateChange)="dateChange()" [min] ="startDate">
                    <mat-datepicker #endDatePicker startView="year" [touchUi]="touchEnabled"></mat-datepicker>
                    <mat-datepicker-toggle [for]="endDatePicker" class="input-group-addon no-padding mat-icon-overide"></mat-datepicker-toggle>
                </div>

            </div>
            
        </div>

        <div *ngIf="requirementsMet()" class="mb-3">
            <i class="fa fa-check green-check"></i>
            All requirements met
        </div>

        <button class="btn btn-primary btn-block btn-block-wrap" (click)="downloadDoc()" [disabled]="!this.startDate && !this.endDate && !this.allPeriodType " [hidden]="!dossierDownloadButtonVisible">
            <i class="fa fa-fw fa-cloud-download"></i>
            Export Selected Years to Dossier in Word
        </button>

    </div>

    <div *ngIf="!requirementsMet()" class="mb-3">
        <div class="alert alert-warning" style="margin-top: 1em;">
            <i class="fa fa-warning"></i>
            {{dossier.ExportStatus.Message}}
        </div>
    </div>

    <div style="padding-top: 7px;"></div>

    <span style="font-weight: bold;">Other Exports</span>

    <div class="card container-box">
        <div style="padding-top: 8px;"></div>
        <button class="btn btn-primary btn-block btn-block-wrap" (click)="downloadThemesAndProjectsDoc()" [disabled]="saving">
            <i class="fa fa-fw fa-cloud-download"></i>
            Export ALL Themes and Projects to Word
        </button>	
        <button class="btn btn-success btn-block btn-block-wrap" (click)="downloadExcel()" [disabled]="saving">
            <i class="fa fa-fw fa-cloud-download"></i>
            Export ALL FTE, CRC, and Activities to Excel
        </button>
    </div>

    <academic-report-submission 
        [submissionType]="SubmissionType.ThemesProjectsActivitiesANRMMP"
        btnClass="btn-block btn-secondary btn-block-wrap my-3">
    </academic-report-submission> 
</div>